module.exports = __webpack_public_path__ + "img/woman.8532be0d.png";